import ConversationsApp from '../utils/conversations';
import ConversationActions from '../actions/conversation';

const WebNotifications = {};

WebNotifications.subscribe = function() {
  if (window.App.cable) {
    window.App.cable.subscriptions.create('WebNotificationsChannel', {
      received: function(data) {
        if (ConversationsApp.Store) {
          var store = ConversationsApp.Store;

          if (data.destroy) {
            if (store.getState().activeConversation.id === data.room_id) {
              store.dispatch(ConversationActions.selectUnload());
            }

            store.dispatch(ConversationActions.remove({ id: data.room_id }));
          } else if (store.getState().activeConversation.id === data.room_id) {
            store.dispatch(ConversationActions.fetchActive({ id: data.room_id }, { reorder: true, notify: true }));
          } else {
            store.dispatch(ConversationActions.fetchInactive({ id: data.room_id }, { notify: true }));
          }
        }

        window.updateNotificationCount();
      }
    });
  }
};

export default WebNotifications;
